<!--  -->
<template>
  <div class="tewbox">
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="template_name"
        label="模板名称"
        width="180"
        align="center"
      />
      <el-table-column
        prop="template_id_short"
        label="模板编号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="address"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { templatemessagelib } from '@/api/sourceMaterial.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: {
    PaginationRight
  },
  data() {
    return {
      query: {
        page: 1,
        pageSize: 10
      },
      tableData: [],
      total: null
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    sendrs() {
      this.temlist()
    },
    async temlist() {
      const data = await templatemessagelib(this.query)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    // 分页
    fetchPageSize(e) {
      this.query.pageSize = e
      this.temlist()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.temlist()
    },
    choose(item) {
      this.$emit('callback', item)
      console.log('item', item)
    }

  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.tewbox{
  padding: 10px;
}
</style>
